import {Component,Prop, Vue} from 'vue-property-decorator';
import QRDialog from "@/views/Users/QRDialog";
import {User} from "@/models/User";
import {InstanceLoader} from "@/support/InstanceLoader";

@Component({
  components: {QRDialog}
})
export default class Mfa extends Vue {
  @Prop({default: null})
  protected user!: User;
  protected isOpeningQRDialog: boolean = false;

  protected openDialog()
  {
    this.isOpeningQRDialog = true;
  }
}

